import {
  CAR_OPTIONS,
  CHILDREN_OPTIONS,
  GENDER_OPTIONS,
  HOUSE_OPTIONS,
  INCOME_OPTIONS,
  MARITAL_OPTIONS,
  type MatchProfile,
} from "./adminConfig";

export type EditFieldType = "text" | "number" | "date" | "select" | "selectCustom" | "textarea";

export interface EditField {
  key: keyof MatchProfile;
  label: string;
  type: EditFieldType;
  options?: string[];
  required?: boolean;
  full?: boolean;
  placeholder?: string;
}

export interface EditGroup {
  title: string;
  icon: string;
  fields: EditField[];
}

export const EDUCATION_OPTIONS = ["初中及以下", "高中/中专", "大专", "本科", "硕士", "博士"];

export const EDIT_GROUPS: EditGroup[] = [
  {
    title: "基本信息",
    icon: "ri-user-3-line",
    fields: [
      { key: "name", label: "姓名", type: "text", required: true, placeholder: "请输入姓名" },
      { key: "gender", label: "性别", type: "select", options: GENDER_OPTIONS, required: true },
      { key: "age", label: "年龄（岁）", type: "number", placeholder: "如：58" },
      { key: "birth_date", label: "出生年月日", type: "date" },
      { key: "height", label: "身高（cm）", type: "number", placeholder: "如：165" },
      { key: "weight", label: "体重（kg）", type: "number", placeholder: "如：62" },
      { key: "education", label: "学历", type: "select", options: EDUCATION_OPTIONS },
    ],
  },
  {
    title: "生活状况",
    icon: "ri-home-heart-line",
    fields: [
      { key: "marital_status", label: "婚姻状况", type: "select", options: MARITAL_OPTIONS },
      { key: "children_status", label: "子女情况", type: "select", options: CHILDREN_OPTIONS },
      { key: "residence", label: "现居城市", type: "text", placeholder: "如：北京" },
      { key: "hometown", label: "籍贯", type: "text", placeholder: "如：河北石家庄" },
      { key: "occupation", label: "职业", type: "text", placeholder: "如：退休教师" },
      { key: "income", label: "年收入", type: "selectCustom", options: INCOME_OPTIONS },
      { key: "house_status", label: "住房情况", type: "select", options: HOUSE_OPTIONS },
      { key: "car_status", label: "车辆情况", type: "select", options: CAR_OPTIONS },
    ],
  },
  {
    title: "联系方式",
    icon: "ri-contacts-line",
    fields: [
      { key: "phone", label: "手机号", type: "text", required: true, placeholder: "请输入手机号" },
      { key: "wechat", label: "微信号", type: "text", placeholder: "选填" },
    ],
  },
  {
    title: "自我与择偶",
    icon: "ri-heart-2-line",
    fields: [
      { key: "hobbies", label: "兴趣爱好", type: "textarea", full: true, placeholder: "如：养花、太极、旅游" },
      { key: "self_intro", label: "自我介绍", type: "textarea", full: true, placeholder: "简单介绍本人情况" },
      { key: "matchmaker_note", label: "匹配记录", type: "textarea", full: true, placeholder: "记录该会员的匹配、介绍情况" },
      { key: "partner_age_min", label: "期望对方年龄（起）", type: "number", placeholder: "如：55" },
      { key: "partner_age_max", label: "期望对方年龄（止）", type: "number", placeholder: "如：65" },
      { key: "partner_requirements", label: "择偶要求", type: "textarea", full: true, placeholder: "对另一半的期望" },
    ],
  },
];